/*
 * Created by David Adams
 * https://codeshack.io/multi-select-dropdown-html-javascript/
 * 
 * Released under the MIT license
 */
class MultiSelect {
    #filters = new Set();
    #results_count;
    constructor(element, options = {}) {
        let defaults = {
            placeholder: 'Select item(s)',
            max: null,
            search: false,
            selectAll: false,
            listAll: true,
            closeListOnItemSelect: false,
            name: '',
            width: '',
            height: '',
            dropdownWidth: '',
            dropdownHeight: '',
            data: [],
            current_filters: '',
            onChange: function() {},
            onSelect: function() {},
            onUnselect: function() {}
        };
        this.options = Object.assign(defaults, options);
        this.selectElement = typeof element === 'string' ? document.querySelector(element) : element;
        for(const prop in this.selectElement.dataset) {
            if (this.options[prop] !== undefined) {
                this.options[prop] = this.selectElement.dataset[prop];
            }
        }
        this.name = this.selectElement.getAttribute('name') ? this.selectElement.getAttribute('name') : 'multi-select-' + Math.floor(Math.random() * 1000000);
        if (!this.options.data.length) {
            let options = this.selectElement.querySelectorAll('option');
            for (let i = 0; i < options.length; i++) {
                this.options.data.push({
                    value: options[i].value,
                    text: options[i].innerHTML,
                    selected: options[i].selected,
                    html: options[i].getAttribute('data-html'),
                    tooltip: options[i].getAttribute('data-tooltip')
                });
            }
        }
        this.element = this._template();
        this.selectElement.replaceWith(this.element);
        this._updateSelected();
        this._eventHandlers();
        this.selectNextOption = this.selectNextOption.bind(this);
        this.selectPreviousOption = this.selectPreviousOption.bind(this);
        
    }

    _template() {
        const escapeHtml = (value) => {
            return String(value ?? '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;');
        };

        let optionsHTML = '';
        let selectedOption = '';
        let ariaSelected = '';

        for (let i = 0; i < this.data.length; i++) {
            if (i === 0) {
                selectedOption = 'select-popout__item--current';
                ariaSelected = 'true';
            } else {
                selectedOption = '';
                ariaSelected = 'false';
            }

            const optionClasses =
                `tooltip ${selectedOption} select-popout__option multi-select-option` +
                (this.selectedValues.includes(this.data[i].value) ? ' multi-select-selected' : '');

            const safeValue = escapeHtml(this.data[i].value);
            const safeTooltip = escapeHtml(this.data[i].tooltip);
            const optionContent = escapeHtml(this.data[i].html || this.data[i].text);

            optionsHTML += `
                <li class="${escapeHtml(optionClasses)}" role="option" id="sleep-concerns-${i}" data-value="${safeValue}" aria-selected="${ariaSelected}">
                    <span class="multi-select-option-text select-popout__option">${optionContent}</span>
                    <span id="tooltip-${i}" class="tooltip-text sr-only">${safeTooltip}</span>
                </li>
            `;
        }

        let selectAllHTML = '';
        if (this.options.selectAll === true || this.options.selectAll === 'true') {
            selectAllHTML = `<div class="multi-select-all">
                <span class="multi-select-option-text">Select all</span>
            </div>`;
        }

        const hiddenInputsHTML = this.selectedValues
            .map(value => `<input type="hidden" name="${escapeHtml(this.name)}[]" value="${escapeHtml(value)}">`)
            .join('');

        const safeId = this.selectElement.id ? escapeHtml(this.selectElement.id) : '';
        const safeCurrentFilters = escapeHtml(this.options.current_filters);
        const safeName = escapeHtml(this.name);
        const safePlaceholder = escapeHtml(this.placeholder);

        const wrapperStyle = `text-wrap:nowrap;${this.width ? 'width:' + escapeHtml(this.width) + ';' : ''}${this.height ? 'height:' + escapeHtml(this.height) + ';' : ''}`;
        const buttonStyle = `${this.width ? 'width:' + escapeHtml(this.width) + ';' : ''}${this.height ? 'height:' + escapeHtml(this.height) + ';' : ''}`;
        const listStyle = `${this.options.dropdownWidth ? 'width:' + escapeHtml(this.options.dropdownWidth) + ';' : ''}${this.options.dropdownHeight ? 'height:' + escapeHtml(this.options.dropdownHeight) + ';' : ''}`;

        let template = `
            <div class="multi-select select-wrapper pdp-variant-3 ${safeName}"${safeId ? ` id="${safeId}"` : ''} data-current-filters="${safeCurrentFilters}" style="${wrapperStyle}">
                <span id="sleep-concerns" class="option_name">Sleep Concerns</span>    
                ${hiddenInputsHTML}
                <button role="combobox" aria-haspopup="listbox" aria-labelledby="sleep-concerns selected-sleep-concerns" aria-activedescendant="sleep-concerns" aria-controls="sleep-concerns-list" aria-expanded="false" class="multi-select-header select-popout__toggle" style="${buttonStyle}">
                    <span id="selected-sleep-concerns" class="multi-select-header-max">${this.options.max ? this.selectedValues.length + '/' + this.options.max : ''}</span>
                    <span class="multi-select-header-placeholder select-popout__value">${safePlaceholder}</span>
                </button>
                <ul id="sleep-concerns-list" role="listbox" aria-labelledby="sleep-concerns" aria-multiselectable="true" class="multi-select-options select-popout__value" style="${listStyle}">
                    ${this.options.search === true || this.options.search === 'true' ? '<input type="text" class="multi-select-search" placeholder="Search...">' : ''}
                    ${selectAllHTML}
                    ${optionsHTML}
                </ul>
                <div id="tooltip"></div>
            </div>
        `;

        let element = document.createElement('div');
        element.setAttribute('id', 'sleep-concerns-filter');
        element.innerHTML = template;
        return element;
    }
    #showAll() {
        document.getElementById('no-results').classList.remove('hidden');
        document.querySelectorAll('.product-wrapper__item').forEach(item => {
            item.classList.remove('hidden');
        });
    }

    selectNextOption() {
        let options = document.querySelectorAll('.multi-select .multi-select-option');
        options.forEach(function(element) { // Corrected the callback syntax
            element.querySelector('.tooltip-text').classList.remove('active');
            element.querySelector('.tooltip-text').classList.add('sr-only');
        });
        var currentOption = document.querySelector('.multi-select .select-popout__item--current');
        if(currentOption !== undefined) {
            var currentOptionIndex = Array.prototype.slice.call(options).indexOf(currentOption);
            
            if(currentOptionIndex + 1 < options.length) {
                var nextOption = options[currentOptionIndex + 1];
                currentOption.classList.remove('select-popout__item--current');
                nextOption.classList.add('select-popout__item--current'); // Select the previous option
                this.#showTooltip(nextOption);
            }
        }
    }

    selectPreviousOption() {
        let options = document.querySelectorAll('.multi-select .multi-select-option');
        options.forEach(function(element) { // Corrected the callback syntax
            element.querySelector('.tooltip-text').classList.remove('active');
            element.querySelector('.tooltip-text').classList.add('sr-only');
        });
        var currentOption = document.querySelector('.multi-select .select-popout__item--current');
        if (currentOption) {
            let currentOptionIndex = Array.prototype.indexOf.call(options, currentOption);
            if (currentOptionIndex - 1 >= 0) {
                let previousOption = options[currentOptionIndex - 1];
                currentOption.classList.remove('select-popout__item--current');
                previousOption.classList.add('select-popout__item--current'); // Select the previous option
                this.#showTooltip(previousOption);
            }
        }
    }

    selectOption(e){
        let element=e.target;
        let selectedItemId = element.closest('#sleep-concerns').querySelector('.select-popout__item--current').id;
        element.setAttribute('aria-activedescendant', selectedItemId);
        element.closest('#sleep-concerns').querySelectorAll('.select-popout__option').forEach(item => {
            item.setAttribute('aria-selected', 'false');
        })
        element.closest('#sleep-concerns').querySelector('.select-popout__item--current').setAttribute('aria-selected', 'true');
    }

    #showTooltip(option) {
        option.querySelector('.tooltip-text').classList.add('active');
        option.querySelector('.tooltip-text').classList.remove('sr-only');
    }
    #hideTooltip(option) {
        option.querySelector('.tooltip-text').classList.remove('active');
        option.querySelector('.tooltip-text').classList.add('sr-only');
    }

  #createHeaderOption(value, text) {
    const chip = document.createElement('span');
    chip.className = 'multi-select-header-option tooltip select-popout__value';
    chip.dataset.value = value;

    const label = document.createElement('span');
    label.className = 'multi-select-header-option-label';
    label.textContent = text;

    const removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'multi-select-header-option-remove';
    removeBtn.setAttribute('aria-label', `Remove ${text}`);
    removeBtn.innerHTML = '&times;';

    removeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const listOption = this.element.querySelector(
        `.multi-select-option[data-value="${CSS.escape(value)}"]`
      );
      if (listOption?.classList.contains('multi-select-selected')) {
        listOption.click();
      }
    });

    chip.appendChild(label);
    chip.appendChild(removeBtn);
    return chip;
  }

    #adjustFilter(filterValue, action) {
        document.getElementById('no-results').classList.add('hidden');
        let existing_element_filters = document.getElementById(this.selectElement.id).dataset.currentFilters;
        let current_element = document.getElementById(this.selectElement.id);
        let filters_concerns = document.getElementById('sleep-concerns').dataset.currentFilters;
        let filters_position = document.getElementsByClassName('sleep-position')[0].dataset.selectedFilter;
        let filters_size = document.getElementsByClassName('mattress-size')[0].dataset.selectedFilter;
        let filters_type = document.getElementById('mattress_type').dataset.currentFilters;

        if (filters_concerns) {
            const current_filters = filters_concerns.split(',');
            current_filters.forEach(element => {
                if(element != '') {
                    this.#filters.add(element);
                }
            });
        }
        if (filters_position) {
            this.#filters.add(filters_position);
        }
        if (filters_size) {
            this.#filters.add(filters_size);
        }
        if (filters_type) {
            const current_filters = filters_type.split(',');
            current_filters.forEach(element => {
                if(element != '') {
                    this.#filters.add(element);
                }
            });
        }
        
        if(action === "add") {
            this.#filters.add(filterValue);
            if(existing_element_filters) {
                current_element.dataset.currentFilters = existing_element_filters + "," + filterValue;
            } else {
                current_element.dataset.currentFilters = filterValue;
            }
        } 
        if(action === "remove") {
            this.#filters.delete(filterValue);
            let re = new RegExp("(" + filterValue + ",|" + filterValue + ")", "g");
            current_element.dataset.currentFilters = existing_element_filters.replace(re, "");
        }
        this.#results_count = 0;
        document.querySelectorAll('.product-wrapper__item').forEach(item => {
            if((typeof item.dataset.tags !== "undefined" && item.dataset.tags !== null) && this.#filters.size != 0){
                item.classList.remove('hidden');
                const filtersArray = [...this.#filters];
                const hasTag = filtersArray.every(el => item.dataset.tags.includes(el));
                if (!hasTag){
                    this.#results_count++;
                    item.classList.add('hidden');
                }
            } else {
                item.classList.remove('hidden');
            }
            if(this.#results_count == 6){
                this.#showAll();
            }
        });
    }

    _eventHandlers() {
        let headerElement = this.element.querySelector('.multi-select-header');

        const getOptionText = (option) => {
            return option.querySelector('.multi-select-option-text')?.textContent ?? '';
        };

        const createHiddenInput = (value) => {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = `${this.name}[]`;
            input.value = value;
            return input;
        };

        headerElement.addEventListener('keydown', (e) => {
            switch (e.key) {
                case 'ArrowUp':
                    e.preventDefault();
                    this.selectPreviousOption();
                    this.selectOption(e);
                    break;

                case 'ArrowDown':
                    e.preventDefault();
                    this.selectNextOption();
                    this.selectOption(e);
                    break;

                case 'Tab':
                    document.querySelector('#sleep-concerns-filter .select-popout__toggle')?.classList.remove('multi-select-header-active');
                    var currentOption = document.querySelector('.multi-select .select-popout__item--current');
                    this.#hideTooltip(currentOption);
                    break;

                case 'Escape':
                    e.preventDefault();
                    document.querySelector('#sleep-concerns-filter .select-popout__toggle')?.classList.remove('multi-select-header-active');
                    var currentOption = document.querySelector('.multi-select .select-popout__item--current');
                    this.#hideTooltip(currentOption);
                    break;

                case 'Enter':
                case ' ':
                    e.preventDefault();
                    if (document.querySelector('#sleep-concerns-filter .select-popout__toggle')?.classList.contains('multi-select-header-active')) {
                        document.querySelector('.multi-select-option.select-popout__item--current')?.click();
                        var currentOption = document.querySelector('.multi-select .select-popout__item--current');
                        this.#hideTooltip(currentOption);
                    } else {
                        document.querySelector('#sleep-concerns-filter .select-popout__toggle')?.classList.add('multi-select-header-active');
                    }
                    break;
            }
        });

        this.element.querySelectorAll('.multi-select-option').forEach(option => {
            option.onclick = () => {
                let selected = true;
                const optionText = getOptionText(option);
                const optionValue = option.dataset.value;

                if (!option.classList.contains('multi-select-selected')) {
                    if (this.options.max && this.selectedValues.length >= this.options.max) {
                        return;
                    }

                    option.classList.add('multi-select-selected');

                    if (this.options.listAll === true || this.options.listAll === 'true') {
                        const newHeaderOption = this.#createHeaderOption(optionValue, optionText);

                        if (this.element.querySelector('.multi-select-header-option')) {
                            let opt = Array.from(this.element.querySelectorAll('.multi-select-header-option')).pop();
                            opt.after(newHeaderOption);
                        } else {
                            headerElement.prepend(newHeaderOption);
                        }
                    }

                    this.element.querySelector('.multi-select').prepend(createHiddenInput(optionValue));

                    const selectedItem = this.data.find(data => data.value == optionValue);
                    if (selectedItem) {
                        selectedItem.selected = true;
                    }
                } else {
                    option.classList.remove('multi-select-selected');

                    this.element.querySelectorAll('.multi-select-header-option').forEach(headerOption => {
                        if (headerOption.dataset.value == optionValue) {
                            headerOption.remove();
                        }
                    });

                    this.element.querySelectorAll('input[type="hidden"]').forEach(input => {
                        if (input.value == optionValue) {
                            input.remove();
                        }
                    });

                    const selectedItem = this.data.find(data => data.value == optionValue);
                    if (selectedItem) {
                        selectedItem.selected = false;
                    }

                    selected = false;
                }

                if (this.options.listAll === false || this.options.listAll === 'false') {
                    this.element.querySelectorAll('.multi-select-header-option').forEach(el => el.remove());

                    const summary = document.createElement('span');
                    summary.className = 'multi-select-header-option tooltip select-popout__value';
                    summary.textContent = `${this.selectedValues.length} selected`;
                    headerElement.prepend(summary);
                }

                if (!this.element.querySelector('.multi-select-header-option')) {
                    const placeholder = document.createElement('span');
                    placeholder.className = 'multi-select-header-placeholder select-popout__value';
                    placeholder.textContent = this.placeholder;
                    headerElement.prepend(placeholder);
                } else if (this.element.querySelector('.multi-select-header-placeholder')) {
                    this.element.querySelector('.multi-select-header-placeholder').remove();
                }

                if (this.options.max) {
                    const maxEl = this.element.querySelector('.multi-select-header-max');
                    if (maxEl) {
                        maxEl.textContent = this.selectedValues.length + '/' + this.options.max;
                    }
                }

                if (this.options.search === true || this.options.search === 'true') {
                    const searchEl = this.element.querySelector('.multi-select-search');
                    if (searchEl) {
                        searchEl.value = '';
                    }
                }

                this.element.querySelectorAll('.multi-select-option').forEach(option => option.style.display = 'flex');

                if (this.options.closeListOnItemSelect === true || this.options.closeListOnItemSelect === 'true') {
                    headerElement.classList.remove('multi-select-header-active');
                }

                this.options.onChange(optionValue, optionText, option);

                if (selected) {
                    this.#adjustFilter(optionValue, 'add');
                    this.options.onSelect(optionValue, optionText, option);
                } else {
                    this.#adjustFilter(optionValue, 'remove');
                    this.options.onUnselect(optionValue, optionText, option);
                }
            };

            option.onmouseover = () => {
                if (window.screen.width > 767) {
                    this.#showTooltip(option);
                }
            };

            option.onmouseout = () => {
                this.#hideTooltip(option);
            };

            option.addEventListener('focusin', function () {
                option.querySelector('.tooltip-text')?.classList.add('active');
            });

            option.addEventListener('focusout', function () {
                option.querySelector('.tooltip-text')?.classList.remove('active');
            });
        });

        headerElement.onclick = () => {
            const expanded = headerElement.getAttribute('aria-expanded') === 'true';
            headerElement.setAttribute('aria-expanded', String(!expanded));
            headerElement.classList.toggle('multi-select-header-active');

            document.querySelectorAll('custom-select').forEach((el) => {
                el.classList.remove('active');
                el.querySelector('.select-popout__list')?.classList.remove('select-popout__list--visible');
                el.querySelector('.select-popout__toggle')?.setAttribute('aria-expanded', false);
                el.isExpanded = false;
            });
        };

        if (this.options.search === true || this.options.search === 'true') {
            let search = this.element.querySelector('.multi-select-search');
            search.oninput = () => {
                this.element.querySelectorAll('.multi-select-option').forEach(option => {
                    const text = getOptionText(option).toLowerCase();
                    option.style.display = text.indexOf(search.value.toLowerCase()) > -1 ? 'flex' : 'none';
                });
            };
        }

        if (this.options.selectAll === true || this.options.selectAll === 'true') {
            let selectAllButton = this.element.querySelector('.multi-select-all');
            selectAllButton.onclick = () => {
                let allSelected = selectAllButton.classList.contains('multi-select-selected');
                this.element.querySelectorAll('.multi-select-option').forEach(option => {
                    let dataItem = this.data.find(data => data.value == option.dataset.value);
                    if (dataItem && ((allSelected && dataItem.selected) || (!allSelected && !dataItem.selected))) {
                        option.click();
                    }
                });
                selectAllButton.classList.toggle('multi-select-selected');
            };
        }

        if (this.selectElement.id && document.querySelector('label[for="' + this.selectElement.id + '"]')) {
            document.querySelector('label[for="' + this.selectElement.id + '"]').onclick = () => {
                headerElement.classList.toggle('multi-select-header-active');
            };
        }

        document.addEventListener('click', event => {
            if (!event.target.closest('.' + this.name) && !event.target.closest('label[for="' + this.selectElement.id + '"]')) {
                headerElement.classList.remove('multi-select-header-active');
                headerElement.setAttribute('aria-expanded', 'false');
                var currentOption = document.querySelector('.multi-select .select-popout__item--current');
                this.#hideTooltip(currentOption);
            }
        });
    }

    _updateSelected() {
        const header = this.element.querySelector('.multi-select-header');
        const placeholder = this.element.querySelector('.multi-select-header-placeholder');

        if (!header) return;

        if (this.options.listAll === true || this.options.listAll === 'true') {
            this.element.querySelectorAll('.multi-select-option.multi-select-selected').forEach(option => {
                const text = option.querySelector('.multi-select-option-text')?.textContent ?? '';
                const value = option.dataset.value;
                header.prepend(this.#createHeaderOption(value, text));
            });
        } else if (this.selectedValues.length > 0) {
            const summary = document.createElement('span');
            summary.className = 'multi-select-header-option';
            summary.textContent = `${this.selectedValues.length} selected`;
            header.prepend(summary);
        }

        if (this.element.querySelector('.multi-select-header-option') && placeholder) {
            placeholder.remove();
        }
    }

    get selectedValues() {
        return this.data.filter(data => data.selected).map(data => data.value);
    }

    get selectedItems() {
        return this.data.filter(data => data.selected);
    }

    set data(value) {
        this.options.data = value;
    }

    get data() {
        return this.options.data;
    }

    set selectElement(value) {
        this.options.selectElement = value;
    }

    get selectElement() {
        return this.options.selectElement;
    }

    set element(value) {
        this.options.element = value;
    }

    get element() {
        return this.options.element;
    }

    set placeholder(value) {
        this.options.placeholder = value;
    }

    get placeholder() {
        return this.options.placeholder;
    }

    set name(value) {
        this.options.name = value;
    }

    get name() {
        return this.options.name;
    }

    set width(value) {
        this.options.width = value;
    }

    get width() {
        return this.options.width;
    }

    set height(value) {
        this.options.height = value;
    }

    get height() {
        return this.options.height;
    }

}
document.querySelectorAll('[data-multi-select]').forEach(select => new MultiSelect(select));